"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createRangeSteps = function createRangeStepsForRange(fieldData, trackId) {
  if (!trackId) {
    return [];
  }

  var barElement = trackId.current;

  if (!barElement) {
    return [];
  }

  var step = Number(fieldData.control.options.step);
  var handleWidth = 40;
  var barWidth = barElement.offsetWidth - handleWidth;
  var range = Number(fieldData.control.options.max) - Number(fieldData.control.options.min);
  var steps = range / step;
  var stepInPixels = barWidth / steps;
  var threshold = stepInPixels / 2;
  var stepValues = [];
  var stepValue = Number(fieldData.control.options.min);
  var stepPixels = 0;

  for (var i = 0; i < steps + 1; i += 1) {
    stepValues.push({
      threshold: threshold,
      value: stepValue,
      pixels: stepPixels
    });
    stepValue += step;
    stepPixels += stepInPixels;
  }

  return stepValues;
};

var _default = createRangeSteps;
exports["default"] = _default;